import { render, staticRenderFns } from "./EditExercisePronunciation.vue?vue&type=template&id=5e672d8d&"
import script from "./EditExercisePronunciation.vue?vue&type=script&lang=ts&"
export * from "./EditExercisePronunciation.vue?vue&type=script&lang=ts&"
import style0 from "./EditExercisePronunciation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports